// Genre family taxonomy — the bundled snapshot of the genre picker's grouping + per-genre
// audio keys. The DATA now lives in the canonical suggestionTaxonomy.json (served by Rails so
// content edits ship without an extension rebuild); this module re-exports the genre slice with
// its types so existing importers (suggestionInfo grouping, sampleExamples audio resolution) are
// unchanged. For runtime-updated grouping use taxonomyStore; audio resolution intentionally uses
// this bundled copy, since clips are bundled assets.
import taxonomy from './suggestionTaxonomy.json'

export interface GenreEntry {
  value: string // the paste-ready genre string, copied verbatim from the Ruby list
  key: string // canonical per-genre sample slug; spelling variants of one genre share a key,
  // distinct subgenres each own a unique key. A clip lives at /audio/genres/<key>.mp3 once shipped.
  desc?: string // OPTIONAL short description — include ONLY for non-obvious subgenres
}

export interface GenreFamily {
  key: string // the Ruby family key (e.g. "lo-fi", "r&b")
  label: string // a concise human Title-Case family name
  entries: GenreEntry[]
}

// Shown at rest in the genre picker — a curated ~18-genre set so a newcomer isn't faced with
// all 500+; the search box reveals the rest. See suggestionTaxonomy.json for the source.
export const POPULAR_GENRES: string[] = taxonomy.genre.popular

export const GENRE_FAMILIES: GenreFamily[] = taxonomy.genre.families as GenreFamily[]
